export const autocompleteGroupedFormater = (arrOptions, sortedKey) =>
  arrOptions.map((option) => {
    const firstLetter = option[sortedKey][0].toUpperCase();
    return {
      firstLetter: /[0-9]/.test(firstLetter) ? '0-9' : firstLetter,
      ...option,
    };
  });
